var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-layout',[_c('base-card',[_c('search-bar'),_vm._v(" "),_c('calendar',_vm._b({staticClass:"lg:min-h-[768px]"},'calendar',_vm.$props,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }